export const selectAcceptTerms = state => state.acceptTerms.data;
